import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { usePageStore } from '@/store';
import bannerMixins from '../../mixins/banner';
import banner from '../../components/banner.vue';
import { PrefetchMethod } from '@/config';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import agentShare from './standard/agent-share.vue';

export default {
    mixins: [bannerMixins, colorMixin(), spaceMixin()],
    i18next: {
        ns: 'md-banner'
    },
    data: function() {
        return {
            mode: '',
            agentId: 0,
            videoOption: {
                previewSrc: '',
                src: '',
                autoplay: true,
                playInline: false,
                showProgress: false,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: true
            },
            title: '',
            subTitle: ''
        };
    },
    [PrefetchMethod]() {
        return this.getAgentInfo(this.agentId);
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "agents": store => store.agents
        }),
        agent() {
            let res = this.agents[this.agentId] || {};
            let socialNetworks = res.agentSocialNetworks;
            let fullName = res.firstName + ' ' + res.lastName;
            return Object.assign(res, {
                socialNetworks,
                fullName
            });
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        useType() {
            return this.type;
        },
        backgroundAttachment() {
            return this.backgroundAttachmentFixed ? 'fixed' : 'initial'
        }
    },
    methods: {
        ...rootMapActions(usePageStore, {
            "getAgentInfo": "getAgentInfo"
        }),
        doVideoPlay() {
            this.$refs.banner && this.$refs.banner.doVideoPlay();
        }
    },
    components: {
        banner,
        agentShare
    }
};
